import { useCallback } from 'react'
import { clearAllStorage } from '../../utils/storage'
import { AuthLoginParams, createLoginUrl } from '../../utils/urls'
import { LoginHandler, RedirectParam } from '../../context'
import { login } from './login'

export interface UseLoginParams<Url extends string = string> {
  accessTokenKey: string
  authorizationUrl: Url
  loginParams: AuthLoginParams
}

const useLogin = ({
  accessTokenKey,
  authorizationUrl,
  loginParams,
}: UseLoginParams) => {
  const handleLogin: LoginHandler = (param?) => {
    const redirect = (param as RedirectParam)?.redirect || ''
    clearAllStorage(accessTokenKey)
    const loginUrl = createLoginUrl(authorizationUrl, loginParams)
    if (loginUrl) {
      login({ redirect, loginUrl })
    }
  }
  return useCallback(handleLogin, [
    accessTokenKey,
    authorizationUrl,
    loginParams,
  ])
}

export default useLogin
